module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forum-avatar"
  }, [(_vm.src) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.src
    }
  }) : _c('div', {
    staticClass: "avatar-icon"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-20fcd091!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/forum/avatar.vue
// module id = 1992
// module chunks = 2